module.exports = __webpack_public_path__ + "media/apps/app-download-d-phone-443333e9.jpg";